'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var buttonsView_styles = require('./buttons-view.styles-2ac85217.js');

var ButtonsView = function (_a) {
    var buttons = _a.buttons, onSave = _a.onSave, alwaysHideOnButtonClick = _a.alwaysHideOnButtonClick;
    var onSaveHandler = React.useCallback(function (handler) { return function () {
        if (handler)
            handler();
        if (onSave)
            onSave();
    }; }, [onSave]);
    if (buttons && buttons.length > 0) {
        return (React__default.createElement(buttonsView_styles.ButtonsContainer, { className: "button-view" }, buttons === null || buttons === void 0 ? void 0 : buttons.map(function (_a, item) {
            var buttonTitle = _a.title, handler = _a.handler, variant = _a.variant, isLoading = _a.isLoading, disabled = _a.disabled, size = _a.size;
            return (React__default.createElement(buttonsView_styles.StyledButton, { key: buttonTitle, disabled: disabled, onClick: (item === 0 || alwaysHideOnButtonClick) ? onSaveHandler(handler) : handler, text: buttonTitle, variant: variant || constants.BUTTON_VARIANT.PRIMARY, loading: isLoading, size: size }));
        })));
    }
    return null;
};

exports.ButtonsView = ButtonsView;
